import { forwardRef, ForwardedRef } from 'react';
import * as Styles from './CandidateSearch.styles';
import CandidateSearchList, { CandidateSearchListType } from '../CandidateSearchList';
import SearchInput, { SearchInputType } from '../SearchInput';

type CandidateSearchContainerType = {
  isCandidateSearchListVisible: boolean;
};
type CandidateSearchType = CandidateSearchListType & SearchInputType & CandidateSearchContainerType;

const CandidateSearch = (
  {
    candidates,
    value,
    isLoading,
    hasError,
    hasFetched,
    onChangeHandler,
    containerRef,
    isCandidateSearchListVisible,
    ...props
  }: CandidateSearchType,
  ref: ForwardedRef<HTMLInputElement>
): JSX.Element => (
  <Styles.Box {...props}>
    <SearchInput ref={ref} value={value} onChangeHandler={onChangeHandler} />
    {isCandidateSearchListVisible && (
      <CandidateSearchList
        containerRef={containerRef}
        candidates={candidates}
        isLoading={isLoading}
        hasError={hasError}
        hasFetched={hasFetched}
      />
    )}
  </Styles.Box>
);

export default forwardRef(CandidateSearch);
